import getCookie from '@/utils/getCookie'

const GOOGLE_REDIRECT_STORAGE_KEY = 'accountRedirect'
const GOOGLE_LOGIN_METHOD = 'google'
export const LOGIN_ANALYTICS_COOKIES = ['cgSignUp', 'cgLogin']

const VALID_HOSTS = [
  'corporategift.com',
  'dev.corporategift.com',
  'staging.corporategift.com',
  'account.corporategift.com',
  'account.dev.corporategift.com',
  'account.staging.corporategift.com',
]

export default {
  computed: {
    routerQuery () { return this.$route.query },
    redirect () {
      const { redirect } = this.routerQuery

      if (!redirect) { return null }

      try {
        const parsedURL = new URL(redirect);
        if (parsedURL.protocol !== 'https:') { return null }
        if (!VALID_HOSTS.includes(parsedURL.host)) { return null }

        return parsedURL.href;
      } catch (err) {
        // probably this is a page to account like /dashboard
        return redirect;
      }
    },
    googleURL () {
      return `${process.env.VUE_APP_MAGENTO_URL}/google/start`
    },
  },
  methods: {
    onGoogleSSO () {
      const { redirect } = this

      if (redirect) {
        sessionStorage.setItem(GOOGLE_REDIRECT_STORAGE_KEY, redirect)
      } else {
        this.forgetGoogleRedirect()
      }
    },
    forgetGoogleRedirect () {
      sessionStorage.removeItem(GOOGLE_REDIRECT_STORAGE_KEY)
    },
    loginAnalyticsEvent () {
      const rawEvent = LOGIN_ANALYTICS_COOKIES.map(getCookie).find(Boolean)

      try {
        return rawEvent ? JSON.parse(rawEvent) : null
      } catch (err) {
        console.warn('login analytics cookie is not valid JSON', err)
        return null
      }
    },
    followRedirect (redirect) {
      if (redirect.startsWith('https://')) {
        window.location.href = redirect
      } else {
        this.$router.push(redirect).catch(() => {})
      }
    },
    redirectLoggedInUser () {
      const { redirect } = this

      this.forgetGoogleRedirect()
      this.$store.dispatch('header/loadHeader')
      sessionStorage.removeItem('authenticationEmail')

      if (redirect) {
        this.followRedirect(redirect)
      } else {
        window.location.href = '/dashboard'
      }
    },
    onLoginWithGoogleRedirect (loginEvent) {
      const redirect = sessionStorage.getItem(GOOGLE_REDIRECT_STORAGE_KEY)
      const userIsLoggedIn = this.$store.state.headerAuth?.userIsLoggedIn ?? false
      this.forgetGoogleRedirect()

      if (redirect && userIsLoggedIn && loginEvent?.method === GOOGLE_LOGIN_METHOD) {
        this.followRedirect(redirect)
      }
    },
  },
}
